import { SharinSingleCollaboratorExpenseResponse } from '@/app/models/sharingDetails';
import formatterMonetaryValue from '@/app/utils/numberUtils';
import { styled, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const RowTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  paddingRight: theme.spacing(2),
  backgroundColor: '#FCE5CD',
}));

type RuleClassificationTableGridParams = {
  rows: SharinSingleCollaboratorExpenseResponse[];
};

function SharingCollaboratorExpenseDetail({ rows }: RuleClassificationTableGridParams) {
  const { t } = useTranslation('sharingDetails');

  const groupedRows = useMemo(() => {
    const grouped: { [key: string]: number } = {};

    rows.forEach((item) => {
      if (!grouped[item.expenseGroup]) {
        grouped[item.expenseGroup] = 0;
      }
      grouped[item.expenseGroup] += item.value;
    });

    return Object.entries(grouped).map(([expenseGroup, total]) => ({
      expenseGroup,
      total: parseFloat(total.toFixed(2)),
    }));
  }, [rows]);

  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableBody>
          {groupedRows.length > 0 ? (
            <TableRow>
              <RowTableCell colSpan={12}>
                <Typography component="span" sx={{ fontSize: '12px' }}>
                  {groupedRows.map((row, index) => (
                    <span key={row.expenseGroup}>
                      <b>{row.expenseGroup}</b> - {formatterMonetaryValue(row.total)}
                      {index < groupedRows.length - 1 && ' '}
                    </span>
                  ))}
                </Typography>
              </RowTableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={12}>
                <Typography variant="subtitle2">{t('no.data.found')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SharingCollaboratorExpenseDetail;
